import { Button, Flex, Select, useToast } from "@chakra-ui/react";
import { t } from "i18next";
import { useState } from "react";
import { ContractTaskDto, UpdateTaskRequest, ContractTaskStatus } from "../../../../../../autogen/bff-api";
import { useApiError } from "../../../../../../common/errors/useApiError";
import { useSaveNow } from "../../../../../../common/editing/save-coordinator";
import { contractTaskEditorId } from "../useContractTaskEditor";

interface Props {
  task: ContractTaskDto;
  onEditComleted: () => void;
  onCancel: () => void;
}

export const EditStatus = ({ task, onEditComleted, onCancel }: Props) => {
  const [status, setStatus] = useState(task.status);
  const options = [
    { value: ContractTaskStatus.Open, label: t("Open") },
    { value: ContractTaskStatus.Completed, label: t("Completed") },
  ];
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();
  const displayer = useApiError();
  const { saveNow } = useSaveNow<ContractTaskDto, UpdateTaskRequest>(contractTaskEditorId(task.id));
  return (
    <Flex flexDirection={"column"}>
      <Select
        borderRadius={"7px"}
        size="sm"
        value={status ?? undefined}
        onChange={(e) => {
          setStatus(e.target.value as ContractTaskStatus);
        }}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Select>
      <Flex mt="10px">
        <Button
          id="save-status-button"
          variant={"solid"}
          colorScheme="teal"
          size="xs"
          isLoading={isLoading}
          onClick={async () => {
            setIsLoading(true);
            try {
              await saveNow({
                status,
              });
              setIsLoading(false);
              onEditComleted();
            } catch (e) {
              setIsLoading(false);
              toast({
                title: t("Could not edit status"),
                description: displayer.message(e),
                status: "error",
              });
            }
          }}
        >
          {t("Save")}
        </Button>
        <Button variant={"solid"} colorScheme="gray" size="xs" ml="5px" onClick={onCancel}>
          {t("Cancel")}
        </Button>
      </Flex>
    </Flex>
  );
};
